import { render } from "./ConsumerList.vue?vue&type=template&id=bc6970bc"
import script from "./ConsumerList.vue?vue&type=script&lang=js"
export * from "./ConsumerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__